import React, { useState } from 'react';
import { useLazyWorkplaceMemberQuery } from '../../graphql/graphql';
import useNotification from '../../Hooks/useNotification.hook';
import useTranslation from '../../Hooks/useTranslation';
import apiClient from '../../Services/ApiClient';
import { useAppContext } from '../../Services/AppContext';
import Text from '../Base/Text/Text';
import CancelButton from '../Button/CancelButton';
import ConfirmButton from '../Button/ConfirmButton';
import Loading from '../Loading';

// @ts-ignore
import styles from './DeletePatient.module.scss';

interface Props {
	patientId?: string;
	onClose: () => void;
	onPatientDelete: () => void;
}

const DeletePatient: React.FC<Props> = ({
	patientId,
	onClose,
	onPatientDelete,
}) => {
	const [isLoading, setIsLoading] = useState(false);
	const { showNotificationSuccess, showNotificationAlert } = useNotification();
	const [getWorkplaceMember] = useLazyWorkplaceMemberQuery();
	const appContext = useAppContext();
	const { t } = useTranslation();

	const handleConfirm = async () => {
		try {
			setIsLoading(true);
			const localWorkplaceId = appContext.workplaceId;
			if (patientId) {
				const { workplaceMember } = await getWorkplaceMember({
					userId: patientId,
					workplaceId: localWorkplaceId,
				}).unwrap();

				if (workplaceMember) {
					const result = await apiClient.delete(
						`/workplaces/${localWorkplaceId}/members/${workplaceMember.id}`,
					);

					if (result?.data) {
						showNotificationSuccess({
							content: t('base.shared.userDeleted'),
						});

						onClose();
						onPatientDelete();

						// @ts-ignore
						window.location.href = '/kartoteka-new';
					}
				}
			}

			onClose?.();
		} catch (e) {
			if (e.response?.data?.displayableError) {
				showNotificationAlert({
					content: e.response.data.message,
				});
			}
		} finally {
			setIsLoading(false);
		}
	};

	if (isLoading) return <Loading />;

	return (
		<div className={styles.wrapper}>
			<div className={styles.content}>
				<div className={styles.text}>
					<Text tx='component.patient.removePatientConfirm' inline />
				</div>
			</div>
			<div className={styles.controls}>
				<CancelButton onClick={() => onClose()} />
				<ConfirmButton onClick={handleConfirm} />
			</div>
		</div>
	);
};

export default DeletePatient;
